import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between"
};
const _hoisted_2 = {
  class: "mt-1"
};
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-2"
};
const _hoisted_4 = {
  key: 0,
  class: "status-badge is-purple"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-slate-400"
};
const _hoisted_9 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_10 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_11 = {
  class: "space-y-4"
};
const _hoisted_12 = {
  class: "space-y-2"
};
const _hoisted_13 = {
  class: "flex items-center gap-2 text-sm text-slate-700"
};
const _hoisted_14 = {
  class: "flex items-center gap-2 text-sm text-slate-700"
};
const _hoisted_15 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_16 = ["disabled"];
import { ref, reactive, computed } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { meetingApi } from '@/api/meeting';
import AppModal from '@/components/AppModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
export default {
  __name: 'MeetingAttendeeSection',
  props: {
    meetingId: {
      type: [Number, String],
      default: null
    },
    attendees: {
      type: Array,
      default: () => []
    },
    meetingStatus: {
      type: String,
      default: ''
    },
    // 当前用户为会议组织者/主持人（由详情抽屉按归属计算传入）；添加/移除/出勤标记仅管理者
    canManage: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changed'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    // 参会人/出勤变化后通知抽屉刷新详情
    const emit = __emit;
    const isPlanned = computed(() => props.meetingStatus === 'PLANNED');
    const isEnded = computed(() => props.meetingStatus === 'ENDED');

    // 确认状态徽章（文案直接用后端 desc 字段）
    const ATTEND_STATUS_CLASS = {
      PENDING: 'is-neutral',
      ACCEPTED: 'is-success',
      DECLINED: 'is-danger'
    };
    // 出勤徽章
    const ATTENDANCE_CLASS = {
      PRESENT: 'is-success',
      ABSENT: 'is-danger'
    };

    // 添加参会人弹窗
    const showAddModal = ref(false);
    const saving = ref(false);
    const addForm = reactive({
      userIds: [],
      attendType: 'NORMAL'
    });
    const handleOpenAdd = () => {
      addForm.userIds = [];
      addForm.attendType = 'NORMAL';
      showAddModal.value = true;
    };
    const handleAddSubmit = async () => {
      if (!addForm.userIds.length) {
        ElMessage.warning('请选择参会人');
        return;
      }
      saving.value = true;
      try {
        await meetingApi.addAttendees(props.meetingId, {
          userIds: addForm.userIds,
          attendType: addForm.attendType
        });
        ElMessage.success('参会人已添加');
        showAddModal.value = false;
        emit('changed');
      } catch (error) {
        // 错误已由拦截器提示
        console.error('添加参会人失败:', error);
      } finally {
        saving.value = false;
      }
    };

    // 移除参会人（仅待召开会议）
    const handleRemove = async attendee => {
      try {
        await ElMessageBox.confirm(`确定要移除参会人「${attendee.userName || '#' + attendee.userId}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.removeAttendee(props.meetingId, attendee.userId);
        ElMessage.success('参会人已移除');
        emit('changed');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('移除参会人失败:', error);
        }
      }
    };

    // 出勤标记（仅已结束会议；再次点同一标记视为取消标记，传 NONE）
    const handleMark = async (attendee, attendance) => {
      const next = attendee.attendance === attendance ? 'NONE' : attendance;
      try {
        await meetingApi.markAttendance(props.meetingId, attendee.userId, {
          attendance: next
        });
        emit('changed');
      } catch (error) {
        // 错误已由拦截器提示
        console.error('出勤标记失败:', error);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[7] || (_cache[7] = _createElementVNode("dt", {
        class: "text-xs font-medium text-slate-500"
      }, "参会人", -1)), isPlanned.value && __props.canManage ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "table-action-button is-primary",
        title: "添加参会人",
        "aria-label": "添加参会人",
        onClick: handleOpenAdd
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })], -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("dd", _hoisted_2, [__props.attendees && __props.attendees.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attendees, attendee => {
        return _openBlock(), _createElementBlock("span", {
          key: attendee.userId,
          class: "inline-flex items-center gap-1.5 rounded-md bg-slate-50 px-2 py-1 text-sm text-slate-700"
        }, [_createTextVNode(_toDisplayString(attendee.userName || `#${attendee.userId}`) + " ", 1), _createElementVNode("span", {
          class: _normalizeClass(['status-badge', ATTEND_STATUS_CLASS[attendee.attendStatus] || 'is-neutral'])
        }, _toDisplayString(attendee.attendStatusDesc || attendee.attendStatus), 3), attendee.attendType === 'TEMP' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(attendee.attendTypeDesc || '临时'), 1)) : _createCommentVNode("", true), attendee.attendance && attendee.attendance !== 'NONE' ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(['status-badge', ATTENDANCE_CLASS[attendee.attendance] || 'is-neutral'])
        }, _toDisplayString(attendee.attendanceDesc || attendee.attendance), 3)) : _createCommentVNode("", true), isPlanned.value && __props.canManage ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "table-action-button is-danger",
          title: "移除",
          "aria-label": "移除",
          onClick: $event => handleRemove(attendee)
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))], 8, _hoisted_5)) : _createCommentVNode("", true), isEnded.value && __props.canManage ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createElementVNode("button", {
          type: "button",
          class: "table-action-button is-success",
          title: "出席",
          "aria-label": "出席",
          onClick: $event => handleMark(attendee, 'PRESENT')
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1)]))], 8, _hoisted_6), _createElementVNode("button", {
          type: "button",
          class: "table-action-button is-danger",
          title: "缺席",
          "aria-label": "缺席",
          onClick: $event => handleMark(attendee, 'ABSENT')
        }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))], 8, _hoisted_7)], 64)) : _createCommentVNode("", true)]);
      }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_8, "暂无参会人"))]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showAddModal.value,
          size: "sm",
          onClose: _cache[5] || (_cache[5] = $event => showAddModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[12] || (_cache[12] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "添加参会人", -1)), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[0] || (_cache[0] = $event => showAddModal.value = false)
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 参会人 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(UserSelector, {
            modelValue: addForm.userIds,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addForm.userIds = $event),
            multiple: true,
            placeholder: "请选择参会人"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("label", {
            class: "form-label"
          }, "参会类型", -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("label", _hoisted_13, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => addForm.attendType = $event),
            type: "radio",
            value: "NORMAL",
            class: "form-radio"
          }, null, 512), [[_vModelRadio, addForm.attendType]]), _cache[14] || (_cache[14] = _createTextVNode(" 正式", -1)), _cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "（加入日程并发送邀请）", -1))]), _createElementVNode("label", _hoisted_14, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => addForm.attendType = $event),
            type: "radio",
            value: "TEMP",
            class: "form-radio"
          }, null, 512), [[_vModelRadio, addForm.attendType]]), _cache[16] || (_cache[16] = _createTextVNode(" 临时", -1)), _cache[17] || (_cache[17] = _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "（仅记录在会议，不发送邀请）", -1))])])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[4] || (_cache[4] = $event => showAddModal.value = false)
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: saving.value,
            onClick: handleAddSubmit
          }, _toDisplayString(saving.value ? '提交中...' : '确定'), 9, _hoisted_16)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]))]);
    };
  }
};